<template>
 <div class="container">
    <div class="error_section">
      <p class="error_section_subtitle">Oops Page is not available !</p>
      <h1 class="error_title">
        404
      </h1>
      <div class="back-button" @click="$router.replace('/')">
      <button class="back" aria-label="Home" click="back">Back to home
      </button>
      </div>
    </div>
 </div>
</template>

<script>
export default {
  name: 'page-not-found',
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.container{
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: left;
  vertical-align: middle;
  line-height: 1;
}

.error_section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.error_section_subtitle {
  color: #ff6300;
  text-transform: uppercase;
  letter-spacing: 5pt;
  font-weight: 700;
  font-size: 1rem;
}
.error_title {
  font-size: 10rem;
  transition: all 0.2s ease;
}
.error_section .error_title:hover {
  transition: all 0.2s ease;
  text-shadow: var(--x-shadow) var(--y-shadow) 10px #1A1A1A;
}

.back {
  padding: 0.625rem 1rem;
  background-color: #ff6300;
  border: none;
  cursor: pointer;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1.5pt;
  font-weight: 500;
  font-size: 1rem;
}
.back:hover {
  transform: translateY(5px);
  transition: ease-out 0.2s all;
}
</style>
